/**
 * Default runtime configuration. Merged with config delivered by the server
 * via /assets/config/config.json at boot. Use environment variables (prefixed
 * with TKW_) to override values in production.
 */
export interface AppConfig {
  name: string;
  tenantId: number;
  apis: {
    baseUri: string;
  };
  mfa: {
    /** issuer label shown in the authenticator app for the totp account. */
    issuer: string;
  };
}

export const defaultConfig: AppConfig = {
  name: 'TKW Mobile',
  tenantId: 11,
  apis: {
    baseUri: ''
  },
  mfa: {
    issuer: 'myMedax TKW'
  }
};
